import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { ro } from './locales/ro';

export const defaultLocale = 'ro';

void i18n.use(initReactI18next).init({
  resources: { ro },
  lng: defaultLocale,
  fallbackLng: defaultLocale,
  interpolation: { escapeValue: false }, // React already escapes.
  returnNull: false,
});

export default i18n;
